import {
  SESSION_STORAGE_KEYS,
  readSessionStorageValue,
} from "../constants/sessionStorage";

function decodeJwtPayload(token) {
  try {
    const parts = String(token || "").split(".");
    if (parts.length !== 3) return null;

    const normalizedPayload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const paddedPayload = normalizedPayload.padEnd(
      normalizedPayload.length + ((4 - (normalizedPayload.length % 4)) % 4),
      "=",
    );

    return JSON.parse(atob(paddedPayload));
  } catch {
    return null;
  }
}

export function hasValidPortalSession() {
  const token = readSessionStorageValue(SESSION_STORAGE_KEYS.TOKEN, "").trim();
  const sessionId = readSessionStorageValue(
    SESSION_STORAGE_KEYS.SESSION_ID,
    "",
  ).trim();

  if (!token || !sessionId) {
    return false;
  }

  if (
    token === "undefined" ||
    token === "null" ||
    sessionId === "undefined" ||
    sessionId === "null"
  ) {
    return false;
  }

  if (/\s/.test(token)) {
    return false;
  }

  const payload = decodeJwtPayload(token);
  if (payload?.exp && Date.now() >= payload.exp * 1000) {
    return false;
  }

  return true;
}

export function canRefreshExpiredPortalSession() {
  const token = readSessionStorageValue(SESSION_STORAGE_KEYS.TOKEN, "").trim();
  const sessionId = readSessionStorageValue(SESSION_STORAGE_KEYS.SESSION_ID, "").trim();
  const refreshToken = readSessionStorageValue("RefreshToken", "").trim();
  const payload = decodeJwtPayload(token);

  return Boolean(
    sessionId &&
      refreshToken &&
      payload?.exp &&
      Date.now() >= payload.exp * 1000,
  );
}
